export default __webpack_public_path__ + "static/media/Armbands of the Howling Giant.70977c25.jpg";